import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter, Router } from 'react-router-dom'
import 'react-app-polyfill/ie11';
import History from './Navigation/History';

/** Componentes para inicializar el sistema */
import App from './Components/App';
import AppScrollToTop from './Components/Layout/AppScrollToTop';

/** Service worker */
import * as serviceWorker from './serviceWorker';

/**
 * @function
 * Función principal para renderizar el contenido del componente.
 */
ReactDOM.render(
  <BrowserRouter>
    <AppScrollToTop>
      <Router history={History}>
        <App />
      </Router>
    </AppScrollToTop>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
